export const environment = {
  gaId: 'UA-8594346-26', // Development id
  production: false,
  mode: 'stable',
};
